// extracted by mini-css-extract-plugin
export default {"form":"BonusCatalogDateSetup_form__k1o6M","datePickerFormItem":"BonusCatalogDateSetup_datePickerFormItem__TsaKD","select":"BonusCatalogDateSetup_select__-PEUG"};